import { gql } from "lib/apolloClient";
import { workbookTemplateFragment } from "./WorkbookTemplateFragments";

export const getWorkbookTemplateQueryV2 = gql`
  query getWorkbookTemplates(
    $id: ID!
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $searchText: String!
    $first: Int
    $after: String
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM]
    $status: ORGANIZATION_RESOURCE_STATUS_ENUM
    $courseIds: [ID!]
    $createdBy: [ID!]
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        organizationResources(types: $types, filters: { states: $states }) {
          ...organizationResourceBasicDetailsItem
        }
      }
    }
  }

  ${workbookTemplateFragment.organizationResourceBasicDetailsItem}
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookTemplateFolderQuery = gql`
  query getWorkbookTemplateFolder(
    $id: ID!
    $types: ENTITY_TYPE_ENUM!
    $searchText: String
    $first: Int
    $after: String
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM]
  ) {
    node(id: $id, type: $types) {
      id
      ... on OrganizationResource {
        childrenV2(
          first: $first
          after: $after
          filters: { searchText: $searchText, states: $states }
        ) {
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
          edges {
            node {
              ... on OrganizationResource {
                id
                label
                type
                resourceType
                state
                attachment {
                  ...attachmentFragment
                }
                createdBy {
                  id
                  firstName
                  middleName
                  lastName
                }
              }
            }
          }
        }
      }
    }
  }
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookSchoolTemplateQuery = gql`
  query getWorkbookSchoolTemplateQuery(
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $organizationId: ID!
    $curriculumProgramId: ID!
    $searchText: String!
    $first: Int
    $after: String
    $status: ORGANIZATION_RESOURCE_STATUS_ENUM
    $states: [ORGANIZATION_RESOURCE_STATE_ENUM]
    $courseIds: [ID!]
    $createdBy: [ID!]
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        workbookTemplates(curriculumProgramId: $curriculumProgramId) {
          isSuccess
          warning
          organizationResource {
            ...organizationResourceBasicDetailsItem
          }
        }
      }
    }
  }

  ${workbookTemplateFragment.organizationResourceBasicDetailsItem}
  ${workbookTemplateFragment.attachmentFragment}
`;

export const getWorkbookSchoolTemplatesCountQuery = gql`
  query getWorkbookSchoolTemplatesCountQuery(
    $types: [ORGANIZATION_RESOURCE_TYPE_ENUM!]
    $organizationId: ID!
    $curriculumProgramId: ID!
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        workbookTemplates(curriculumProgramId: $curriculumProgramId) {
          isSuccess
          warning
          organizationResource {
            id
            childrenV2(filters: { types: $types }) {
              resourceTypeBasedCount {
                totalCount
              }
            }
          }
        }
      }
    }
  }
`;
